export default "__VITE_ASSET__XUBRB4Hy__"